import { inject, observer } from 'mobx-react';
import React from 'react'
import { presetTemplates } from '../../../utils/TemplateSizes';
import SlideItem from '../../Buttons/SlideItem';
import PresetTemplate from '../../Inputs/PresetTemplate';
import ScrollArrow from '../../Inputs/ScrollArrow';
import { ReactComponent as CheckRight } from '../../../svg/chevron-right.svg'
import { ReactComponent as CheckLeft } from '../../../svg/chevron-left.svg'
import { fetchDesignJSON } from '../../../services/DesignService';

@inject('templateStore', 'workAreaStore', 'store', 'sidebarStore', 'errorStore', 'saveStore') @observer
class TemplateSlide extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      templates: [
        {
          title: 'blank templates',
          type: 'blank',
          scrollPosition: 0,
          user: true,
          scrollClass: 'slide-wrapper__template-row blank',
          className: 'blank-templates',
          items: []
        }
      ],
      customTemplates: [
        {
          scrollPosition: 0,
          user: true,
          title: 'Your designs',
          scrollClass: 'slide-wrapper__template-row user-content'
        },
        {
          scrollPosition: 0,
          title: 'Free templates',
          scrollClass: 'slide-wrapper__template-row free-templates',
          key: 'free-templates'
        },
        {
          scrollPosition: 0,
          title: 'Facebook posts',
          scrollClass: 'slide-wrapper__template-row facebook-post',
          key: 'facebook-post'
        },
        {
          scrollPosition: 0,
          title: 'Instagram stories',
          scrollClass: 'slide-wrapper__template-row instagram-story',
          key: 'instagram-story'
        },
        {
          scrollPosition: 0,
          title: 'Linkedin posts',
          scrollClass: 'slide-wrapper__template-row linkedin-post',
          key: 'linkedin-post'
        },
        {
          scrollPosition: 0,
          title: 'Twitter posts',
          scrollClass: 'slide-wrapper__template-row twitter-post',
          key: 'twitter-post'
        },
        {
          scrollPosition: 0,
          title: 'Logos',
          scrollClass: 'slide-wrapper__template-row logo',
          key: 'logo'
        },
        {
          scrollPosition: 0,
          title: 'T-Shirts',
          scrollClass: 'slide-wrapper__template-row t-shirt',
          key: 't-shirt'
        },
        {
          scrollPosition: 0,
          title: 'Youtube channel art',
          scrollClass: 'slide-wrapper__template-row youtube-channel-art',
          key: 'youtube-channel-art'
        },
        {
          scrollPosition: 0,
          title: 'Certificates',
          scrollClass: 'slide-wrapper__template-row certificate',
          key: 'certificate'
        },
        {
          scrollPosition: 0,
          title: 'Album covers',
          scrollClass: 'slide-wrapper__template-row album-cover',
          key: 'album-cover'
        },
      ]
    }
  }

  componentDidMount() {
    //fetch templates here
    const copy = this.state.templates.map(t => {
      if (t.type === 'blank') {
        return {
          ...t,
          items: presetTemplates
        }
      }
    })
    const { store: { isTeam, auth } } = this.props
    const { publicDesigns } = this.props.templateStore
    const customTemplates = []
    const categoryList = Object.keys(publicDesigns).map(key => publicDesigns[key])
    const sorted = categoryList.sort((a, b) => b.count - a.count)
    sorted.forEach(category => {
      const { category: key, title } = category
      if (key === 'free-templates') {
        return
      }
      customTemplates.push({
        scrollPosition: 0,
        title,
        scrollClass: `slide-wrapper__template-row ${key}`,
        key
      })
    })
    customTemplates.splice(0, 0, {
      scrollPosition: 0,
      title: 'Free templates',
      scrollClass: `slide-wrapper__template-row free-templates`,
      key: 'free-templates'
    })
    if (auth && isTeam) {
      customTemplates.splice(0, 0, {
        scrollPosition: 0,
        team: true,
        title: 'Team designs',
        scrollClass: 'slide-wrapper__template-row team-content'
      })
    }
    customTemplates.splice(0, 0, {
      scrollPosition: 0,
      user: true,
      title: 'Your designs',
      scrollClass: 'slide-wrapper__template-row user-content'
    })
    this.setState({
      templates: copy,
      customTemplates
    })
  }

  getTemplateContent({ title, icon }) {
    return (
      <div className="sidebar-slide__text-icon">
        <span className="sidebar-slide__text-icon__icon">{icon}</span>
        <span className="sidebar-slide__text-icon__title">{title}</span>
      </div>
    )
  }

  saveChanges(width, height, id) {
    const { sidebarStore } = this.props
    const w = parseInt(width)
    const h = parseInt(height)
    if (w && h) {
      this.props.workAreaStore.updatePage(w, h, sidebarStore.open)
    }
  }

  handlePresetClick(width, height, title) {
    const id = title.split(' ').join('-')
    this.props.workAreaStore.setHidden(false)
    if (this.props.sidebarStore.fullScreen) {
      this.props.sidebarStore.toggleFullscreen()
    }
    this.saveChanges(width, height, id)
  }

  getTemplates(t) {
    const data = this.state.templates.find(({ type }) => type === t)
    if (t === 'blank') {
      return (
        data.items.map((template, idx) => (
          <div key={template.title + idx} className='slide-wrapper__template-item'>
            <PresetTemplate
              {...template}
              onClick={this.handlePresetClick.bind(this)}
            />
          </div>
        ))
      )
    }
  }

  async handleCustomClick(template) {
    const { sidebarStore, workAreaStore, errorStore, store } = this.props
    try {
      if (sidebarStore.fullScreen) {
        workAreaStore.setHidden(false)
        sidebarStore.toggleFullscreen()
      }
      if (!template.free && template.publicTemplate && !store.subscription) {
        store.toggleUpgradeModal('pro-template', true, template.previewUrl, template.height > template.width)
        return
      }
      if (template.publicTemplate) {
        workAreaStore.incrementClick(template.id)
      } else {
        workAreaStore.handlePublicUnlink()
      }
      if (template.lean) {
        errorStore.setErrorMessage(`Loading design template`, false)
        const { data: { designJSON: targetTemplate } } = await fetchDesignJSON(template.id)
        workAreaStore.changePreset(targetTemplate.pages)
        errorStore.setErrorMessage(`Loaded design template`, false)
      } else {
        workAreaStore.changePreset(template.pages)
      }
    } catch (err) {
      errorStore.setErrorMessage('Failed to retrieve design, please try again', true)
    }
  }

  getCustomTemplates(templates, empty, key, isPublic = false) {
    const { keyword } = this.props.templateStore
    let text = keyword && keyword.length ? 'Try searching for something else' : 'You have no existing templates'
    if (isPublic) {
      text = 'Try searching for something else'
    }
    if (empty) {
      return (
        <div className='templates__empty'>
          <span>No templates</span>
          <label className='gray'>{text}</label>
        </div>
      )
    }
    if (!templates) {
      return <div />
    }
    if (key) {
      if (this.props.templateStore.publicDesigns[key].loading && this.props.templateStore.publicDesigns[key].page === 0) {
        return (
          <div className='slide-wrapper__template-item' style={{ width: '100%' }}>
            <div className='loading-icon' style={{
              minHeight: '200px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%'
            }}>
              <img style={{ marginTop: '-25px' }} src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader' />
            </div>
          </div>
        )
      }
      return (
        templates.map((template, idx) => {
          const { title, id, pages } = template
          if (!pages.length) {
            return (
              <div key={idx + id} />
            )
          }
          const t = {
            thumburl: template.thumburl,
            previewUrl: template.previewUrl,
            free: template.free,
            publicTemplate: true,
            lean: template.lean,
            title,
            width: pages[0].width,
            height: pages[0].height,
            pages,
            id,
            custom: true,
          }
          return (
            <div key={id + idx} className='slide-wrapper__template-item'>
              <div className='custom-template'>
                <PresetTemplate
                  {...t}
                  onClick={this.handleCustomClick.bind(this)}
                />
              </div>
            </div>
          )
        })
      )
    }
    if (this.props.templateStore.userDesignsLoading) {
      return (
        <div className='slide-wrapper__template-item' style={{ width: '100%' }}>
          <div className='loading-icon' style={{
            minHeight: '200px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
          }}>
            <img style={{ marginTop: '-25px' }} src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader' />
          </div>
        </div>
      )
    }
    return (
      templates.map((template, idx) => {
        const randomKeyIdx = String(Math.random())
        const { title, id, pages } = template.data
        if (!pages.length) {
          return (
            <div key={idx} />
          )
        }
        const t = {
          thumburl: template.thumburl,
          title,
          width: pages[0].width,
          height: pages[0].height,
          pages,
          id,
          custom: true
        }
        return (
          <div key={id + randomKeyIdx} className='slide-wrapper__template-item'>
            <div className='custom-template'>
              <PresetTemplate
                {...t}
                onClick={this.handleCustomClick.bind(this)}
              />
            </div>
          </div>
        )
      })
    )
  }

  handleScrollLoad(key) {
    this.props.templateStore.paginatePublicDesigns(key)
  }

  resetScroll(e, c, objectName) {
    const copy = [...this.state[objectName]]
    const item = copy.find(({ scrollClass }) => scrollClass === c)
    item.scrollPosition = e.target.scrollLeft
    if (!item.user && !item.team) {
      const c = '.' + item.scrollClass.split(' ').join('.')
      const el = document.querySelector(c)
      const parent = document.querySelector('.slide-wrapper')
      const w = el.scrollWidth
      const pos = el.scrollLeft + parent.clientWidth
      const { loading, more, empty } = this.props.templateStore.publicDesigns[item.key]
      if (w - pos < 200 && !loading && more && !empty) {
        this.handleScrollLoad(item.key)
      }
    }
    this.setState({ [objectName]: copy })
  }

  toggleFull() {
    if (this.props.sidebarStore.fullScreen) {
      this.props.workAreaStore.setHidden(false)
    } else {
      this.props.workAreaStore.setHidden(true)
    }
    this.props.sidebarStore.toggleFullscreen()
  }

  normalizeTemplate(key, template) {
    let title
    let id
    let pages
    let free
    let lean = template.lean
    if (key === 'userDesigns' || key === 'teamDesigns') {
      const { data } = template
      title = data.title
      pages = data.pages
      free = true
      id = data.id
    } else {
      title = template.title
      id = template.id
      pages = template.pages
      free = template.free
    }
    if (!pages[0]) {
      return {
        thumburl: template.thumburl,
        title,
        width: 1080,
        height: 1080,
        pages,
        id,
        custom: true,
        lean,
        free
      }
    }
    return {
      thumburl: template.thumburl,
      hideMarker: key === 'userDesigns' || key === 'teamDesigns',
      title,
      width: pages[0].width,
      height: pages[0].height,
      pages,
      id,
      lean,
      custom: true,
      free
    }
  }

  getPublicTemplateColumn(key, fullScreen) {
    let cols = {
      u_1: [],
      u_2: []
    }
    const { userDesigns, noUserDesigns, teamDesigns, teamDesignsLoading, noTeamDesigns, userDesignsLoading } = this.props.templateStore
    let designs = []
    let loading = true
    let empty = false
    if (key === 'userDesigns') {
      designs = userDesigns
      loading = userDesignsLoading
      empty = noUserDesigns
    } else if (key === 'teamDesigns') {
      designs = teamDesigns
      loading = teamDesignsLoading
      empty = noTeamDesigns
    } else {
      const { designs: des, loading: ld, empty: e } = this.props.templateStore.publicDesigns[key]
      empty = e
      designs = des
      loading = ld
    }
    let stateVal = ''
    if (key === 'userDesigns') {
      stateVal = { title: 'Your designs' }
    } else if (key === 'teamDesigns') {
      stateVal = { title: 'Team designs' }
    } else {
      stateVal = this.state.customTemplates.find(({ key: tk }) => tk === key)
    }
    const publicTemplate = key !== 'userDesigns' || key !== 'teamDesigns'
    if (fullScreen) {
      let index = 0
      cols = []
      designs.forEach(design => {
        if (!cols[index]) {
          cols.push([])
        }
        if (cols[index].includes(design)) {
          return
        }
        cols[index].push(design)
        index += 1
        if (index === 4) {
          index = 0
        }
      })
    } else {
      designs.forEach((design, idx) => {
        if (idx % 2 === 0) {
          cols.u_1.push(design)
        } else {
          cols.u_2.push(design)
        }
      })
    }
    return (
      designs.length ? (
        <>
          {
            fullScreen ? (
              <>
                <div className='templates__title-wrapper vertical'>
                  {
                    <h5 className='templates__title vertical' onClick={() => this.closeColumnView()}>
                      <CheckLeft />
                      {stateVal.title}
                    </h5>
                  }
                </div>
                <div className='templates__vertical-view fullscreen'>
                  {
                    cols.map((column, colIdx) => (
                      <div key={colIdx} className='templates__template-previews vertical-column' style={{ paddingBottom: '75px' }}>
                        {
                          column.map((design, idx) => {
                            const t = this.normalizeTemplate(key, design)
                            const obj = {
                              ...t,
                              publicTemplate
                            }
                            return (
                              <PresetTemplate
                                key={idx + obj.id}
                                {...obj}
                                calcMax={true}
                                onClick={this.handleCustomClick.bind(this)}
                              />
                            )
                          })
                        }
                      </div>
                    ))
                  }
                </div>
              </>
            )
              :
              (
                <>
                  <div className='templates__title-wrapper vertical'>
                    {
                      <h5 className='templates__title vertical' onClick={() => this.closeColumnView()}>
                        <CheckLeft />
                        {stateVal.title}
                      </h5>
                    }
                  </div>
                  <div className='templates__vertical-view'>
                    <div className='templates__template-previews vertical' style={{}}>
                      {
                        cols.u_1.map((design, idx) => {
                          const t = this.normalizeTemplate(key, design)
                          const obj = { ...t, publicTemplate }
                          return (
                            <PresetTemplate
                              key={idx + key}
                              {...obj}
                              maxWidth={145}
                              onClick={this.handleCustomClick.bind(this)}
                            />
                          )
                        })
                      }
                    </div>
                    <div className='templates__template-previews vertical' style={{}}>
                      {
                        cols.u_2.map((design, idx) => {
                          const t = this.normalizeTemplate(key, design)
                          const obj = { ...t, publicTemplate }
                          return (
                            <PresetTemplate
                              key={idx + key}
                              {...obj}
                              maxWidth={145}
                              onClick={this.handleCustomClick.bind(this)}
                            />
                          )
                        })
                      }
                    </div>
                  </div>
                </>
              )
          }
        </>
      )
        :
        (
          <div className='photos__empty'>
            {
              !loading && empty ? (
                <>
                  <span>No designs</span>
                  <label className='gray'>Try searching for something else</label>
                </>
              )
                :
                (
                  <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader' />
                )
            }
          </div>
        )
    )
  }

  setColumnView(key) {
    this.props.templateStore.togglePublicTemplatesColumn(key, true)
    setTimeout(() => {
      const el = document.querySelector('.sidebar-slide.templates')
      if (el) {
        el.scrollTo(0, 0)
      }
    }, 10);
  }

  closeColumnView() {
    this.props.templateStore.togglePublicTemplatesColumn(this.props.templateStore.columnKey, false)
  }

  render() {
    const { templates, customTemplates } = this.state
    const { scrollClass: usrScroll, title: usrTitle } = customTemplates[0]
    const { scrollClass: teamScroll, title: teamTitle } = customTemplates[1]
    const { fullScreen } = this.props.sidebarStore
    const { userDesigns, noUserDesigns, teamDesigns, noTeamDesigns, publicDesigns, columnView, columnKey } = this.props.templateStore
    const className = fullScreen ? `row no-gutters full-screen` : `row no-gutters limited-size`
    return (
      <div className='slide-wrapper templates' style={{ height: '100%', overflowX: 'visible', position: 'relative' }}>
        <div className={className}>
          {
            columnView ? (
              this.getPublicTemplateColumn(columnKey, fullScreen)
            )
              :
              (
                <>
                  {
                    templates.map((data, idx) => {
                      return (
                        <div key={idx + data.type} className='slide-wrapper__templates-wrapper'>
                          <div className='slide-wrapper__templates-title-wrapper'>
                            <h5 className='slide-wrapper__templates-title'>{data.title}</h5>
                          </div>
                          <div className={data.scrollClass} onScroll={e => this.resetScroll(e, data.scrollClass, 'templates')}>
                            <div className={`slide-wrapper__templates ${data.className}`}>
                              {
                                this.getTemplates(data.type)
                              }
                            </div>
                          </div>
                          <ScrollArrow
                            {...data}
                            parentClass={'slide-wrapper'}
                          />
                        </div>
                      )
                    })
                  }
                  {
                    this.props.store.auth ? (
                      <div className='slide-wrapper__templates-wrapper' style={{ marginTop: '20px' }}>
                        <div className='slide-wrapper__templates-title-wrapper'>
                          <h5 className='slide-wrapper__templates-title'>
                            {usrTitle}
                            <span className='slide-wrapper__templates-title__view-all' onClick={() => this.setColumnView('userDesigns')}>View all</span>
                          </h5>
                        </div>
                        <div className={usrScroll} onScroll={e => this.resetScroll(e, usrScroll, 'customTemplates')}>
                          <div className={`slide-wrapper__templates user-templates`}>
                            {
                              this.getCustomTemplates(userDesigns, noUserDesigns)
                            }
                          </div>
                        </div>
                        <ScrollArrow
                          style={{
                            top: 'calc(62% - 30px)'
                          }}
                          {...customTemplates[0]}
                          parentClass={'slide-wrapper'}
                        />
                      </div>
                    )
                      :
                      (
                        undefined
                      )
                  }
                  {
                    this.props.store.auth && this.props.store.isTeam ? (
                      <div className='slide-wrapper__templates-wrapper' style={{ marginTop: '20px' }}>
                        <div className='slide-wrapper__templates-title-wrapper'>
                          <h5 className='slide-wrapper__templates-title'>
                            {teamTitle}
                            <span className='slide-wrapper__templates-title__view-all' onClick={() => this.setColumnView('teamDesigns')}>View all</span>
                          </h5>
                        </div>
                        <div className={teamScroll} onScroll={e => this.resetScroll(e, teamScroll, 'customTemplates')}>
                          <div className={`slide-wrapper__templates team-templates`}>
                            {
                              this.getCustomTemplates(teamDesigns, noTeamDesigns)
                            }
                          </div>
                        </div>
                        <ScrollArrow
                          style={{
                            top: 'calc(62% - 30px)'
                          }}
                          {...customTemplates[1]}
                          parentClass={'slide-wrapper'}
                        />
                      </div>
                    )
                      :
                      undefined
                  }
                  {
                    customTemplates.map((templates, idx) => {
                      return templates.user || templates.team ? (
                        <div key={'usr-ignore' + idx} />
                      )
                        :
                        (
                          <div key={templates.key + idx} className='slide-wrapper__templates-wrapper' style={{ marginTop: '20px', paddingBottom: idx === customTemplates.length - 1 ? '50px' : '0' }}>
                            <div className='slide-wrapper__templates-title-wrapper'>
                              <h5 className='slide-wrapper__templates-title'>{templates.title}
                                <span className='slide-wrapper__templates-title__view-all' onClick={() => this.setColumnView(templates.key)}>View all</span>
                              </h5>
                            </div>
                            <div className={templates.scrollClass} onScroll={e => this.resetScroll(e, templates.scrollClass, 'customTemplates')}>
                              <div className={`slide-wrapper__templates user-templates`}>
                                {
                                  this.getCustomTemplates(publicDesigns[templates.key].designs, publicDesigns[templates.key].empty, templates.key, true)
                                }
                              </div>
                            </div>
                            <ScrollArrow
                              style={{
                                top: 'calc(62% - 30px)'
                              }}
                              {...customTemplates[idx]}
                              parentClass={'slide-wrapper'}
                            />
                          </div>
                        )
                    })
                  }
                </>
              )
          }
        </div>
      </div>
    )
  }


}

/*

  <ScrollArrow
    backwards={true}
    {...data}
    parentClass={'slide-wrapper'}
  />
*/

export default TemplateSlide